// BEAM UI primitive — BarChart (W5). A dependency-free horizontal bar chart (pure Views, no SVG)
// for small labeled series like expenses-by-category. Renders on web + native identically.
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '../../theme';
import { Text } from './Text';

export type BarDatum = { label: string; value: number; valueLabel?: string };

export function BarChart({ data, accessibilityLabel }: { data: BarDatum[]; accessibilityLabel?: string }) {
  const max = data.reduce((m, d) => (d.value > m ? d.value : m), 0) || 1;
  return (
    <View style={styles.wrap} accessibilityLabel={accessibilityLabel}>
      {data.map((d) => {
        const pct = Math.max(2, Math.round((d.value / max) * 100));
        return (
          <View key={d.label} style={styles.row}>
            <View style={styles.labelCol}>
              <Text variant="small" color="secondary" numberOfLines={1}>{d.label}</Text>
            </View>
            <View style={styles.track}>
              <View style={[styles.fill, { width: `${pct}%` }]} />
            </View>
            <View style={styles.valueCol}>
              <Text variant="small" numberOfLines={1}>{d.valueLabel ?? String(d.value)}</Text>
            </View>
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { gap: theme.spacing.xs, marginTop: theme.spacing.sm },
  row: { flexDirection: 'row', alignItems: 'center', gap: theme.spacing.sm },
  labelCol: { width: 110 },
  track: {
    flex: 1,
    height: theme.spacing.md,
    backgroundColor: theme.color.bg.subtle,
    borderRadius: theme.radius.sm,
    overflow: 'hidden',
  },
  fill: { height: '100%', backgroundColor: theme.color.action.primary, borderRadius: theme.radius.sm },
  valueCol: { width: 92, alignItems: 'flex-end' },
});
